module.exports = __webpack_public_path__ + "img/icon_gear.2dda9e2e.svg";